export enum npsQuestionnaire {
  initial = 'initial',
  thanks = 'thanks',
  unhappy = 'unhappy',
  shopList = 'shopList',
}
